<template>
  <div class="equipment-changes">
    <div class="equipment-list">
      <div @click="goBack" class="backDiv" style="display: inline-block; margin-top: 10px; margin-left: 10px; margin-right: auto;">
        <i class="pi pi-arrow-left"></i>
        <span> Equipment Review</span>
      </div>
      <div class="equipment-item" v-for="(item, index) in paginatedEquipment" :key="index">
        <p>{{ item.equipment_type }}</p>
        <div class="vehicle-info">
          <p>{{ item.av_vin  }}</p>
          <p>{{ item.av_make }}</p>
          <p>{{ item.year }}</p>
          <p>${{ item.av_value }}</p>
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination">
      <button :disabled="currentPage === 1" @click="previousPage">Previous</button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button :disabled="currentPage === totalPages" @click="nextPage">Next</button>
    </div>

    <div class="actions">
      <div class="change-text">
        <p class="change-request">Request Changes:</p>
        <p class="note">
          Please note that this does not initiate any changes to your current active policy.
        </p>
      </div>

      <textarea v-model="equipmentChanges" placeholder="Please list the changes you wish to make" class="changes-input"/>
      <button @click="goToAlmostDone" class="btn btn-confirm done-button" :disabled="isButtonDisabled">Done! Submit your info next<i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentChanges',
  data() {
    return {
      equipment:[],
      equipmentChanges: '',
      currentPage: 1,
      itemsPerPage: 4,
      showError: false
    };
  },
  computed: {
    paginatedEquipment() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.equipment.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.equipment.length / this.itemsPerPage);
    },
    isButtonDisabled() {
      return !this.equipmentChanges || this.equipmentChanges.trim().length === 0;
    }
  }, mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
      // Combine tractors and trailers into one equipment array
      this.equipment = [
        ...(data.tractors || []),
        ...(data.trailers || [])
      ];
    } else {
      console.error('No data found in localStorage');
    }

    const equipmentChangesCheck = localStorage.getItem('equipment_changes');
    if (equipmentChangesCheck){
      console.log("equipment changes exist in local");
      this.equipmentChanges = equipmentChangesCheck;
    } else {
      console.log("nothing exists");
    }
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToAlmostDone() {
      if (this.equipmentChanges.trim()) {
        localStorage.setItem('equipment_changes', this.equipmentChanges);
        this.$router.push({
        path: '/submitchanges'
       });
        
      } else {
        this.showError = true;
      }
    },
    goBack() {
      // Store the current scroll position
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Set a flag in sessionStorage before navigation
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);

      // Navigate back
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
i {
  margin-left: 10px;
}

.equipment-changes {
  text-align: center;
  padding: 10px;
}

.equipment-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.equipment-item {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 0px 20px;
  width: 95%;
  margin: 10px 0;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.vehicle-info {
  margin: 20px 0px;
}

.vehicle-info p {
  margin: 5px 0px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.pagination button {
  margin: 0 10px;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  background-color: #004d40;
  color: white;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
}

.changes-input {
  width: 100%;
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 5px;
  margin-bottom: 20px;
  box-sizing: border-box;
  height: 6em; /* Default height for larger screens */
}

@media (max-width: 768px) {
  .changes-input {
    height: 70px; /* Adjust this value for mobile screens */
  }
}

@media (max-width: 480px) {
  .changes-input {
    height: 150px; /* Adjust this value for smaller mobile screens */
  }
}

.note {
  font-size: 0.8em;
  color: #888;
  margin-bottom: 10px;
}

@media (min-width: 1000px) {
  .equipment-changes {
    width: 550px !important;
  }
}
</style>
